<template>
    <!-- 工作动态详情页面 -->
    <section class="container">
        <Header></Header>
        <div class="wrapper workM">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem to="/Dynamic">行业新闻</BreadcrumbItem>
                    <BreadcrumbItem>内容详情</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    行业新闻
                </div>
                <div class="inner-wrapper">
                    <div class="art-title text-center">
                        {{title}}
                    </div>
                    <div class="art-content" v-html="content"></div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "WorkArticle",
        data(){
            return {
                title: '',
                content: ''
            }
        },
        methods: {
            getArticle(){
                var that = this;
                this.$http({
                    url: that.webhost + 'article/detail/' + that.$route.params.workid,
                    method: 'GET',
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.title = data.data.title;
                        that.content = data.data.content;
                    } else {
                        that.$Message.error(data.msg);
                    }
                })
            }
        },
        mounted(){
            this.getArticle();
          this.setTab();
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 90px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .locationM{
        height: 50px;
        line-height: 50px;
    }
    .locationM .ivu-breadcrumb{
        font-size: 15px;
        color: #000;
    }
    .locationM img{
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }
    .inner-wrapper{
        padding: 15px;
    }
    .art-title{
        width: 700px;
        margin: auto;
        margin-top: 30px;
        margin-bottom: 30px;
        font-size: 25px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/views/WorkArticle.vue